import styled, { createGlobalStyle } from 'styled-components'
import { useReducer, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import IngredientBlock from '../components/post/IngredientBlock'
import ReceipeBlock from '../components/post/ReceipeBlock'
import CommonFormInput from '../components/common/CommonFormInput'
import CommonText from '../components/common/CommonText'
import CommonButton from '../components/common/CommonButton'
import CommonModal from '../components/common/CommonModal'
import CommonIconButton from '../components/common/CommonIconButton'
import { postApi } from '../api/api'
import CommonImageUpload from '../components/common/CommonImageUpload'

// writePage 상태
const initialState = {
  title: {
    receipeName: '',
    ingredient: {
      main: [],
      sub: [],
    },
    receipe: [],
  },
  image: '',
}

// reducer
const reducer = (state, action) => {
  switch (action.type) {
    // 레시피 제목 수정
    case 'CHANGE_RECEIPE':
      // 새로운 객체를 만들어서 return 해주는것을 명심하자
      return {
        ...state,
        title: {
          ...state.title,
          [action.name]: action.value,
        },
      }
    // 주재료 보조재료 수정
    case 'CHANGE_INGREDIENT':
      return {
        ...state,
        title: {
          ...state.title,
          ingredient: {
            ...state.ingredient,
            [action.name]: action.value,
          },
        },
      }
    // 레시피 순서 수정
    case 'SET_RECEIPE':
      return {
        ...state,
        title: {
          ...state.title,
          receipe: action.receipe,
        },
      }
    // 메인 사진 지정하기
    case 'SET_IMAGE':
      return {
        ...state,
        image: action.image,
      }
    default:
      return state
  }
}

function PostDetailPage() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const image = useRef()
  const nextOrder = useRef(3)
  const history = useHistory()

  // 작성하기 버튼 클릭시 POST 요청 이벤트
  const posting = async () => {
    const formdata = new FormData()
    // formData 형식으로 만든다.
    formdata.append('title', JSON.stringify(state.title))
    formdata.append('image', state.image)
    formdata.append('channelId', '6182ac24e1ecd063dabf102a')

    // API POST를 요청한다.
    const { resData } = await postApi.createPost(formdata)
    const postId = resData._id
    history.replace(`/post/detail/${postId}`)
  }
  // 레시피 제목 수정 이벤트
  const changeRecipeName = e => {
    const { name, value } = e.target

    dispatch({
      type: 'CHANGE_RECEIPE',
      name,
      value,
    })
  }
  // 레시피 수정 이벤트
  const changeReceipe = e => {
    const { name, value } = e.target

    const newReceipe = state.title.receipe.map(_receipe => {
      return _receipe.id === +name
        ? { ..._receipe, defaultValue: value }
        : _receipe
    })

    dispatch({
      type: 'SET_RECEIPE',
      receipe: newReceipe,
    })
  }
  // 레시피 추가하기 버튼 클릭 이벤트
  const addReceipe = () => {
    const newReceipe = [
      ...state.title.receipe,
      {
        id: nextOrder.current,
        defaultValue: '',
      },
    ]

    dispatch({
      type: 'SET_RECEIPE',
      receipe: newReceipe,
    })

    nextOrder.current += 1
  }
  // 레시피 삭제 클릭 이벤트
  const removeReceipe = e => {
    const { id } = e.target.dataset

    const newReceipe = state.title.receipe.filter(
      _receipe => _receipe.id !== +id,
    )

    dispatch({
      type: 'SET_RECEIPE',
      receipe: newReceipe,
    })
  }
  // 이미지 업로드 이벤트
  const uploadImage = e => {
    const imageFile = e.target.files[0]

    dispatch({
      type: 'SET_IMAGE',
      image: imageFile,
    })

    const reader = new FileReader()

    reader.onload = () => {
      image.current.style.backgroundImage = `url(${reader.result})`
      image.current.style.backgroundSize = 'cover'
    }

    reader.readAsDataURL(imageFile)
  }

  return (
    <>
      <PostWriteStyle />
      {/* 레시피 제목 */}
      <CommonFormInput
        className="mt-50 mb-40"
        label="레시피명"
        fontSize="20px"
        fontWeight={700}
        width="100%"
        onChange={changeRecipeName}
        name="receipeName"
      />

      <div className="mb-40">
        <CommonText
          style={{ marginBottom: '15px' }}
          tag="div"
          fontWeight={700}
          fontSize="20px">
          메인 사진
        </CommonText>
        <CommonImageUpload onChange={uploadImage} image={image} />
      </div>

      {/* 레시피 제작 순서 */}
      <ReceipeBlock
        receipe={state.title.receipe}
        onChange={changeReceipe}
        onClick={removeReceipe}
        isClose
      />
      <div className="flex" />

      <CommonText
        onClick={addReceipe}
        style={{ marginBottom: '70px', cursor: 'pointer' }}
        className="flex"
        fontSize="16px"
        color="#cccccc">
        레시피 추가하기
      </CommonText>
      {/* 작성 완료 버튼 */}
      <div className="flex">
        <CommonButton
          className="mb-40"
          text="작성하기"
          width="100%"
          onClick={posting}
        />
      </div>
    </>
  )
}

const PostWriteStyle = createGlobalStyle`
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }


  .mb-40 {
    margin-bottom: 40px;
  }

  .mt-50 {
    margin-top: 50px
  }

  .image-container {
    width: 100%;
    border: 1px solid #EAEBEC;
    height: 220px;
  }

  .p30 {
    padding: 0 30px;
  }
`

export default PostDetailPage
